import React from 'react';
import AsyncComponent from '../../components/AsyncComponent';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import Grid from '@mui/material/Grid';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { PatternFormat } from 'react-number-format';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';
import Typography from '@mui/material/Typography';

import Cities from '../../data/Cities';
import i18n, { getErrorMessage } from '../../i18n';
import SubscribersService from '../../services/SubscribersService';

import { withStyles } from 'tss-react/mui';
import 'react-toastify/dist/ReactToastify.css';
import './styles.scss';

import SmsImage from '../../images/sms.png';
import SmsImageEn from '../../images/sms-en.png';

class Unsubscription extends AsyncComponent {
  constructor(props) {
    super(props);
    this.state = {
      cities: [],
      citizenCity: '',
      confirmationDialog: false,
      confirmationNumber: '',
      dialogMessage: '',
      dialogTitle: '',
      latlng: null,
      openDialog: false,
      phoneNumber: '',
      smsEnabled: true,
      voiceEnabled: false
    };

    this._confirmUnsubscription = this._confirmUnsubscription.bind(this);
    this._handleClose = this._handleClose.bind(this);
    this._handleInputChange = this._handleInputChange.bind(this);
    this._sendUnsubscription = this._sendUnsubscription.bind(this);
  }

  async componentDidMount() {
    await this._fetchCities();
  }

  async _fetchCities() {
    let cities = await Cities.getInstance().fetchCities();
    cities = cities.filter(city => city.smsEnabled || city.voiceEnabled);

    await this.setStateAsync({ cities });
  }

  async _handleClose(_event, reason) {
    if (reason && reason === 'backdropClick')
      return false;

    await this.setStateAsync({
      confirmationDialog: false,
      confirmationNumber: '',
      dialogTitle: '',
      dialogMessage: '',
      openDialog: false
    });
  }

  async _handleInputChange(event) {
    const { name, value } = event.target;
    await this.setStateAsync({
      [name]: value
    });
  }

  async _toggleSmsEnabled(smsEnabled) {
    await this.setStateAsync({
      smsEnabled,
      voiceEnabled: !smsEnabled
    });
  }

  async _toggleVoiceEnabled(voiceEnabled) {
    await this.setStateAsync({
      smsEnabled: !voiceEnabled,
      voiceEnabled
    });
  }

  async _confirmUnsubscription() {
    if (this.state.confirmationNumber.length !== 6) {
      toast.error(i18n.t('errorYouMustEnterYour6DigitConfirmationCode'));
    }
    else {
      const subscription = {
        phone_number: this.state.phoneNumber,
        city_id: this.state.citizenCity,
        latlng: this.state.latlng,
        subscriber_type: this.state.smsEnabled ? 'sms' : 'voice',
        validation_number: this.state.confirmationNumber,
      };

      const response = await SubscribersService.confirmUnsubscription(subscription);
      if (response.success) {
        await this.setStateAsync({
          confirmationDialog: false,
          confirmationNumber: '',
          dialogTitle: '',
          dialogMessage: '',
          openDialog: false
        });

        toast.success(i18n.t('unsubscriptionCompletedSuccessfully'));
      }
      else {
        toast.error(getErrorMessage(response.errorCode));
      }
    }
  }

  async _sendUnsubscription() {
    console.log(this.state.phoneNumber.length);
    if (this.state.phoneNumber === '') {
      await this.setStateAsync({
        dialogTitle: i18n.t('errorDuringUnsubscription'),
        dialogMessage: i18n.t('pleaseEnterYourPhoneNumberInTheFollowingFormat')
      });
    }
    else if (this.state.citizenCity === '') {
      await this.setStateAsync({
        dialogTitle: i18n.t('errorDuringUnsubscription'),
        dialogMessage: i18n.t('pleaseEnterYourCity')
      });
    }
    else if (this.state.latlng === null) {
      await this.setStateAsync({
        dialogTitle: i18n.t('errorDuringUnsubscription'),
        dialogMessage: i18n.t('pleaseEnterYourAddress')
      });
    }
    else if (this.state.voiceEnabled === false && this.state.smsEnabled === false) {
      await this.setStateAsync({
        dialogTitle: i18n.t('errorDuringUnsubscription'),
        dialogMessage: i18n.t('pleaseEnterYourMeansOfReceivingAlerts')
      });
    }
    else {
      const subscription = {
        phone_number: this.state.phoneNumber,
        city_id: this.state.citizenCity,
        latlng: this.state.latlng,
        subscriber_type: this.state.smsEnabled ? 'sms' : 'voice',
      };

      const response = await SubscribersService.unsubscribe(subscription);
      if (response.success) {
        await this.setStateAsync({
          dialogTitle: i18n.t('confirmationOfYourUnsubscription'),
          dialogMessage: i18n.t('pleaseEnterYour6DigitConfirmationNumber'),
          confirmationDialog: true
        });
      }
      else {
        await this.setStateAsync({
          dialogTitle: i18n.t('errorDuringUnsubscription'),
          dialogMessage: getErrorMessage(response.errorCode),
          confirmationDialog: false
        });
      }
    }
    await this.setStateAsync({ openDialog: true });
  }

  _convertInputToCustomTextMask = React.forwardRef((props, _ref) =>
    <PatternFormat
      {...props}
      format='+1 (###) ###-####'
      mask='_'
      placeholder='+1 (123) 456-7891'
    />
  );

  _renderServicesForm() {
    const { classes } = this.props;

    if (this.state.citizenCity !== '') {
      const city = this.state.cities.find(city => city.cityId === this.state.citizenCity);

      return (
        <div>
          <Typography className={classes.title} component="h6" variant="h6">
            {i18n.t('fromWhatMeansOfCommunicationWouldYouLikeToUnsubscribe')}
          </Typography>
          <div className='serviceChoicesContainer'>
            {
              city.smsEnabled &&
              <FormControlLabel
                control={<Checkbox
                  checked={this.state.smsEnabled}
                  color="default"
                  onChange={async (_, value) => await this._toggleSmsEnabled(value)}
                />}
                label={i18n.t('smsAlerts')}
              />
            }
            {
              city.voiceEnabled &&
              <FormControlLabel
                control={<Checkbox
                  checked={this.state.voiceEnabled}
                  color="default"
                  onChange={async (_, value) => await this._toggleVoiceEnabled(value)}
                />}
                label={i18n.t('automatedCalls')}
              />
            }
          </div>
        </div>
      );
    }
  }

  _renderDialog() {
    return (
      <Dialog
        open={this.state.openDialog}
        onClose={this._handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{this.state.dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {this.state.dialogMessage}
          </DialogContentText>
          {
            this.state.confirmationDialog &&
            <TextField
              variant="standard"
              type='number'
              name='confirmationNumber'
              placeholder={i18n.t('enterYourConfirmationNumber')}
              fullWidth={true}
              label={i18n.t('confirmationNumber')}
              onChange={this._handleInputChange}
              value={this.state.confirmationNumber}
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 6);
              }}
            />
          }
        </DialogContent>
        <DialogActions>
          {
            this.state.confirmationDialog ?
              <React.Fragment>
                <Button onClick={this._handleClose} color='primary'>
                  {i18n.t('cancel')}
                </Button>
                <Button onClick={this._confirmUnsubscription} color='primary'>
                  {i18n.t('confirm')}
                </Button>
              </React.Fragment>
              :
              <Button onClick={this._handleClose} color='primary'>
                {'Ok'}
              </Button>
          }
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <>
        <Grid size={{ xs: 12, sm: 12, md: 7 }}>
          <div className={classes.paper}>
            <form className={classes.form} noValidate>
              <Typography className={classes.title} component="h6" variant="h6">
                {i18n.t('iWouldLikeToUnsubscribeFromTheCarecityAlertServiceImmediately')}
              </Typography>
              <Typography className={classes.text} component="p" variant="body1">
                {i18n.t('unsubscriptionDescription')}
              </Typography>
              <Typography className={classes.title} component="h6" variant="h6">
                {i18n.t('carecityAlertUnsubscriptionForm')}
              </Typography>
              <div className={classes.fieldContainer}>
                <FormControl variant="standard" fullWidth={true} className={classes.field}>
                  <InputLabel>{i18n.t('phoneNumber')}</InputLabel>
                  <Input
                    required
                    variant="outlined"
                    name='phoneNumber'
                    value={this.state.phoneNumber}
                    onChange={this._handleInputChange}
                    id='formatted-text-mask-input'
                    inputComponent={this._convertInputToCustomTextMask}
                  />
                </FormControl>
                <FormControl variant="standard" fullWidth={true} className={classes.field}>
                  <InputLabel>{i18n.t('chooseYourCarecityCity')}</InputLabel>
                  <Select
                    variant="standard"
                    value={this.state.citizenCity}
                    onChange={async (_event) => await this.setStateAsync({ citizenCity: _event.target.value })}
                  >
                    {
                      this.state.cities.map(function (city) {
                        return <MenuItem key={city.cityId} value={city.cityId}>{city.name}</MenuItem>;
                      })
                    }
                  </Select>
                </FormControl>
                <div className={classes.addressFieldContainer}>
                  <GooglePlacesAutocomplete
                    apiKey={process.env.REACT_APP_GOOGLE_KEY}
                    minLengthAutocomplete={5}
                    selectProps={{
                      placeholder: i18n.t('enterYourAddress'),
                      onChange: async result => {
                        const response = await geocodeByAddress(result.label);
                        const latlng = await getLatLng(response[0]);
                        await this.setStateAsync({ latlng });
                      },
                    }}
                  />
                </div>
              </div>
              {this._renderServicesForm()}
              <Grid container spacing={0} justifyContent="flex-start" >
                <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                  <Button
                    fullWidth
                    className={classes.submit}
                    onClick={this._sendUnsubscription}
                    style={{
                      backgroundColor: '#e22929',
                      color: '#fff'
                    }}>
                    {i18n.t('confirmMyUnsubscription')}
                  </Button>
                </Grid>
              </Grid>
              {this._renderDialog()}
            </form>
          </div>
        </Grid>
        <Grid size={{ xs: 0, sm: 0, md: 5 }} className={classes.image} />
      </>
    );
  }
}

const styles = theme => ({
  addressFieldContainer: {
    marginTop: 15
  },
  field: {
    marginBottom: 10,
    width: '100%'
  },
  fieldContainer: {
    marginLeft: 15
  },
  form: {
    marginTop: theme.spacing(5),
    width: '75%',
  },
  image: {
    backgroundImage: `url(${i18n.getLanguageEnabled() === 'en' ? SmsImageEn : SmsImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(0, 4, 0, 4),
  },
  submit: {
    margin: theme.spacing(4, 0, 2),
  },
  text: {
    fontSize: '1rem',
    marginLeft: 15
  },
  title: {
    color: '#6676f7',
    fontFamily: 'Montserrat',
    fontWeight: 700,
    left: 0,
    marginBottom: 15,
    marginLeft: 0,
    marginTop: 25
  }
});

export default withStyles(Unsubscription, styles);

